export default "/images/7b6baf6d0a5b119c2305a19ea142c5bc.avif";